module.exports = __webpack_public_path__ + "static/og-2c8c769ae99e6a04561e6173fbdf3664.png";